import {EvaluatedParameters, Evaluator} from "@cm/graph-v2-final"
import {ImageOpContextHal} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-hal"
import {AnyImageOpHal} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal"
import {
    AnyImageOpResult,
    ImageOpDefinition,
    ImageOpInputsOrNodes,
} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {
    ImageOpOutputsOfType,
    ImageOpParametersOfType,
} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/specializing-image-op-node"
import {ComplexSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/complex-specializing-image-op-node"

export abstract class BasicSpecializingImageOpNode<
    Definition extends ImageOpDefinition<AnyImageOpResult>,
    ImageOpHalClass extends AnyImageOpHal,
> extends ComplexSpecializingImageOpNode<Definition, ImageOpHalClass> {
    constructor(
        private imageOpHalCtor: new (
            context: ImageOpContextHal,
            parameters: EvaluatedParameters<ImageOpParametersOfType<Definition, "hal">>,
        ) => ImageOpHalClass,
        parameters: ImageOpInputsOrNodes<Definition>,
    ) {
        super(parameters)
    }

    protected async createImageOpHal(
        evaluator: Evaluator<ImageOpContextHal>,
        evaluatedParameters: EvaluatedParameters<ImageOpParametersOfType<Definition, "hal">>,
    ): Promise<ImageOpHalClass> {
        return new this.imageOpHalCtor(evaluator.context, evaluatedParameters)
    }

    protected async updateImageOpHal(
        evaluator: Evaluator<ImageOpContextHal>,
        imageOpHal: ImageOpHalClass,
        evaluatedParameters: EvaluatedParameters<ImageOpParametersOfType<Definition, "hal">>,
    ): Promise<void> {
        imageOpHal.setParameters(evaluatedParameters)
    }

    protected getHalResult(
        _evaluator: Evaluator<ImageOpContextHal>,
        imageOpHal: ImageOpHalClass,
        _evaluatedParameters: EvaluatedParameters<ImageOpParametersOfType<Definition, "hal">>,
    ): ImageOpOutputsOfType<Definition, "hal"> {
        return imageOpHal as unknown as ImageOpOutputsOfType<Definition, "hal">
    }
}
